import React, { useState, useEffect } from 'react'
import { ListView } from '@progress/kendo-react-listview';
import { Pager } from '@progress/kendo-react-data-tools';
import { useTranslation } from 'react-i18next';

const ListViewPure = (props) => {
    const {
        data,
        pageable,
        skip = 0,
        take = 0,
        itemRendered,
        listClassName,
        pagerClassName,
    } = props;

    const { t } = useTranslation();

    const initialDataState = {
        skip,
        take,
    };

    const [page, setPage] = useState(initialDataState);

    const handlePageChange = (e) => {
        setPage({
            skip: e.skip,
            take: e.take,
        });
    };

    useEffect(() => {
        setPage(initialDataState);
    }, [data]);

    const noResultsStyles = {
        color: "#2C353C",
        fontSize: "16px",
        fontWeight: 600,
        textAlign: "center",
    };

    return (
        <>
            {
                data.length > 0
                    ? <ListView
                        className={listClassName}
                        data={pageable ? data.slice(page.skip, page.skip + page.take) : data}
                        item={itemRendered}
                    />
                    : <p style={noResultsStyles}>{t("configurationDomainPanel.notResults")}</p>
            }

            {pageable && <Pager
                className={pagerClassName}
                skip={page.skip}
                take={page.take}
                onPageChange={handlePageChange}
                total={data.length}
                info
                buttonCount={5}
                type='numeric'
                previousNext
            />}
        </>
    )
}

export default ListViewPure